import { mapPermissionsToFriendlyName } from '@dispatch/shared';
import { Permission } from '@dispatch/shared/types';
import { CheckBoxListSkeleton } from '@dispatch/web/ui';
import { FormControlLabel, List, ListItem } from '@mui/material';
import { UseFormSetValue } from 'react-hook-form';
import { PermissionCheckBox } from './PermissionCheckbox';

interface PermissionsProps {
  permissions: Permission[];
  formPermissions: string[];
  setValue: UseFormSetValue<{
    name: string;
    permissions: string[];
  }>;
  hasPermissions: boolean;
}

export const Permissions = ({
  permissions,
  hasPermissions,
  ...rest
}: PermissionsProps) => {
  if (permissions?.length <= 0) {
    return <CheckBoxListSkeleton />;
  }
  return (
    <List sx={{ padding: '0 0 0 0.625rem' }}>
      {permissions?.map((permission: Permission, index: number) => {
        return (
          <ListItem key={`${permission?.operationId}_${index}`} disablePadding>
            <FormControlLabel
              control={
                <PermissionCheckBox
                  {...rest}
                  permission={permission}
                  disabled={!hasPermissions}
                />
              }
              label={mapPermissionsToFriendlyName(permission?.operationId)}
            />
          </ListItem>
        );
      })}
    </List>
  );
};
